module.exports = __webpack_public_path__ + "img/latestdetail.ab5e821e.png";